module.exports = __webpack_public_path__ + "img/education_icon.faf9df9e.svg";